
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('title',[_v('Group 54')]),_c('g',{attrs:{"id":"Screens","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Automation","transform":"translate(-608.000000, -52.000000)","fill":"currentColor","fill-rule":"nonzero"}},[_c('g',{attrs:{"id":"Group-13","transform":"translate(138.000000, 48.000000)"}},[_c('g',{attrs:{"id":"Group-54","transform":"translate(470.000000, 4.000000)"}},[_c('path',{attrs:{"d":"M8.1,3.5 L0.3,11.3 C0.1,11.5 0,11.7 0,12 L0,15 C0,15.6 0.4,16 1,16 L4,16 C4.3,16 4.5,15.9 4.7,15.7 L12.5,7.9 L8.1,3.5 Z","id":"Path"}}),_c('path',{attrs:{"d":"M15.7,3.3 L12.7,0.3 C12.3,-0.1 11.7,-0.1 11.3,0.3 L9.5,2.1 L13.9,6.5 L15.7,4.7 C16.1,4.3 16.1,3.7 15.7,3.3 Z","id":"Path"}})])])])])])
          )
        }
      }
    